<template>
<!-- eslint-disable max-len -->
<div class="root">
  <template v-if="isLoadingComplete && !hasLoadedData">
    <div
        style="width: 100%; height: 100%;"
      >
        <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
          <div style="background-color: white; border-radius: 5px; padding: 10px; color: black; font-size: 150%; box-shadow: 2px 2px 25px 1px;">
            You are not assigned any gamulations!  Please contact support to resolve this issue.
          </div>
        </div>
      </div>
  </template>
  <template v-else>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="!isLoadingComplete">
        <blade-spinner>
          <div v-if="loadMessage && loadMessage.length > 0" slot="spinner-neighbor" style="margin-top: 10px; font-size: 24px;">
            {{loadMessage}}
          </div>
        </blade-spinner>
      </div>
      <div v-else-if="classToTest != null && classToTest._id != null && isStudent && !hasPaid"
        style="width: 100%; height: 100%;"
      >
        <!-- TODO @Ian: change the alerts however you want? -->
        <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
          <class-purchase-flow
            :course="classToTest"
            @course-purchased="(free)=>{ hasPaid = true; flashSuccess( { message: free ? `Joined ${classTypeNameLower} successfully` : `${classTypeName} purchased successfully` } ); }"
            @course-already-paid="()=>{ hasPaid = true; }"
          />
        </div>
      </div>
      <div v-else-if="classToTest != null && !hasLoadedData"
        style="width: 100%; height: 100%;"
      >
        <div style="display: flex; width: 100%; height: 100%; min-height: 200px; min-width: 400px; align-items: center; justify-content: center;">
          <div style="background-color: white; border-radius: 5px; padding: 10px; color: black; font-size: 150%; box-shadow: 2px 2px 25px 1px;">
            The settings for this {{classTypeName}} require you to be assigned to a Group before you can continue. Please try again later.
          </div>
        </div>
      </div>
      <div v-else class="content">
        <div class="game-title-bar">
          <div class="game-title-container">
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
              This is what the following line used to be:
              <h1 class="title animated fadeInLeft">{{ game.title || 'REDMERU GAMULATION' }}</h1>
            -->
            <h1 class="animated fadeInLeft" v-html="title"></h1>
          </div>
        </div>
        <div class="content-area">
          <!-- <div v-if="(canSelectGame || canRestartGame)" class="ca-item game-selector animated fadeIn">
            <game-launcher
              backgroundColor="transparent"
              :foregroundColor="selectGameColor"
              labelSize="1.4em"
              padding="0 0 0 0px"
              noCloseButton
              textLeftAligned
              noSubmitButton
              inline
              dropdownForeground="black"
              dropdownBackground="white"
              dropdownOptionForeground="white"
              dropdownOptionBackground="rgba(0, 0, 7, 0.76)"
              borderColor="white"
            />
          </div> -->
          <div class="image-holder ca-item">
            <img :src="heroImage" class="title-image"/>
          </div>
          <div class="start-button-container">
            <button
              v-focus
              class="ca-item btn start-button"
              :disabled="!hasLoadedData"
              tag="button"
              @click.prevent="handleGameStart"
            >
              {{game.startButtonText || 'Start'}}
            </button>
          </div>
        </div>
        <change-password-prompt
          v-if="showChangePasswordPrompt"
          @close="() => { showChangePasswordPrompt = false; }"
        />
      </div>
    </transition>

    <div class="footer-background">
      <footer style="height: 100%; pointer-events: none; display: flex; flex-direction: row; align-items: flex-end; justify-content: space-between; padding: 0 20px;">
        <span class="float-left" style="height: 100%;">
          <span style="height: 100%; display: flex; flex-direction: row;">
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
              This is what the following line used to be:
              <span style="align-self: flex-end; text-align: left;">{{ activeEnvironment.revisionText || 'REV 3.0 JANUARY 2020' }}</span>
            -->
            <span style="height: 100%; align-self: center; text-align: left; display: flex; flex-flow: column nowrap; justify-content: center;" v-html="(activeClass || activeEnvironment).revisionText || activeEnvironment.revisionText || 'REV 3.0 JANUARY 2020'"></span>
          </span>
        </span>
        <span class="float-right" style="height: 100%;">
          <span style="height: 100%; display: flex; flex-direction: row; align-items: center; justify-content: flex-end;">
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks
              This is what the following line used to be:
              <span style="text-align: right;">{{ activeEnvironment.creditsText || 'Powered by ' }}</span>
            -->
            <span style="text-align: right;" v-html="activeEnvironment.creditsText || 'Powered by '"></span>
            <img :src="resolveAssetPath(activeEnvironment.creditsLogo || 'redmerU_loginLogo.png', 'ui/customer')" class="logo"/>
          </span>
        </span>
      </footer>
    </div>
  </template>
</div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapGetters
} from 'vuex';
// import GameLauncher from '@/components/ui/modals/GameLauncher';
import ClassPurchaseFlow from '@/components/braintree/ClassPurchaseFlow';
import ChangePasswordPrompt from '@/components/ui/modals/ChangePasswordPrompt';
import { preloadAssetsFromObject, markInitialGamePreloadComplete } from '@/utils/asset-util';

export default {
  components: {
    // GameLauncher,
    ClassPurchaseFlow,
    ChangePasswordPrompt
  },
  data() {
    return {
      loadMessage: 'Loading...',
      hasLoadedData: false,
      isLoadingComplete: false,
      showChangePasswordPrompt: false,
      hasPaid: false
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'entryState',
      'demo',
      'group',
      'game',
      'canSelectGame',
      'canRestartGame',
      'classTypeName',
      'classTypeNameLower',
      'activeClass',
      'me'
    ]),
    heroImage() {
      return this.resolveAssetPath(this.game.titleImage || 'titleScreen_featureImage-HSG.png', 'ui/customer');
    },
    selectGameColor() {
      return this.activeEnvironment.useLightSelectGameText ? 'rgb(255, 255, 255)' : 'rgb(17,17,17)';
    },
    groupId() {
      return this.$route.params.groupId;
    },
    isDemo() {
      return !this.groupId;
    },
    isStudent() {
      return this.me.roles.some(r => r._id === 'student');
    },
    classToTest() {
      // eslint-disable-next-line no-underscore-dangle
      if (this.activeClass != null && !this.activeClass._invalid) {
        return this.activeClass;
      } else if (this.me.classes != null && this.me.classes[0] != null) {
        return this.me.classes[0];
      }
      return null;
    },
    shouldUseCourseTitle() {
      return this.activeClass != null && this.activeClass.courseName;
    },
    title() {
      if (this.activeClass != null && this.activeClass.courseName
        && !(this.game.titleOverridesClass)) {
        return this.activeClass.courseName;
      }
      return this.game.title || 'REDMERU GAMULATION';
    }
  },
  methods: {
    ...mapActions([
      'getShouldDefaultToHub',
      'startDemo',
      'getMyGroup',
      'flashSuccess',
      'playSound',
      'getActiveGameSetGames'
    ]),
    ...mapMutations([
      'setAudioPlaying',
      'setAudioPause',
    ]),
    tempAlertWrapper(str) {
      // TODO: update alert to use better UX?
      // eslint-disable-next-line no-alert
      alert(str);
    },
    async tryLoadHubPage() {
      try {
        // We only skip the hub for students with a single accessible item (games + classes === 1
        // && no games from game sets).  Therefore we only need to do the getActiveGameSetGames
        // check if the user is a student who has only one item.
        if (!await this.getShouldDefaultToHub()) {
          return false;
        }

        this.$router.replace('/hub');
        return true;
      } catch (err) {
        console.error('Error while loading game sets from demo page, see below...');
        console.error(err);
      }
      return false;
    },
    handleGameStart() {
      this.setAudioPlaying(true);
      this.setAudioPause(false);
      console.log(this.game.startButtonSound);
      if (this.game.startButtonSound) this.playSound({ sound: this.game.startButtonSound });
      this.$router.push(this.entryState);
    }
  },
  async created() {
    this.isLoadingComplete = false;
    try {
      if (this.isDemo) {
        if (this.demo) {
          this.startDemo();
        }

        if (await this.tryLoadHubPage()) {
          return;
        }
      }

      for (let i = 3; i > 0; --i) {
        const skipLegacyAssets = false;
        try {
          const { groupId } = this;

          this.loadMessage = 'Loading save info...';

          await this.getMyGroup(this.groupId ? { groupId } : {});
          this.hasLoadedData = true;
          if (this.isDemo) return this.$router.replace(`/groups/${this.group._id}`);

          this.loadMessage = 'Loading gamulation info...';
          await preloadAssetsFromObject([this.heroImage], undefined, undefined, undefined, skipLegacyAssets);

          this.loadMessage = 'Loading gamulation assets (0%)...';
          // Only wait for backgrounds, characters, and intro/character selection avatars to load
          // await preloadAssetsFromObject(this.$store.state.game, false, /background|character|intro|selected/i, (perc) => {
          //   this.loadMessage = `Loading gamulation assets (${perc}%)...`;
          // }, skipLegacyAssets);

          await preloadAssetsFromObject(this.$store.state.game.requiredAssets, false, undefined, (perc) => {
            this.loadMessage = `Loading gamulation assets (${perc}%)...`;
          }, skipLegacyAssets);

          markInitialGamePreloadComplete(skipLegacyAssets);

          // Preload the rest of the game images, but don't wait
          // preloadAssetsFromObject(this.$store.state.game);

          if (this.activeClass && this.activeClass.skipGameStart) {
            this.handleGameStart();
          }

          return;
        } catch (err) {
          if (this.$router.handleGameError(err)) {
            if (!this.groupId) {
              await this.tryLoadHubPage();
            }
            return;
          }
        }
      }
      this.$router.showGameErrorCritical();
    } finally {
      await this.$nextTick();
      this.isLoadingComplete = true;
      if (!(this.hasLoadedData)) {
        this.$router.replace('/hub');
      }
    }
  },
  mounted() {
    if (this.me.promptChangePassword) {
      this.showChangePasswordPrompt = true;
    }
  }
};
</script>

<style lang="scss" scoped>

.logo {
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-left: 20px;
  //border: 1px solid rgba(255,255,255,0.8);
  border-radius: 2px;
  position: relative;
  bottom: 50px;
}
.title {
  background-color: transparent;
  color: black;
  font-size: 60px;
  font-weight: bold;
  font-family: unset;
  text-shadow: -1px -0.25px white;
  // font-size: 50px;
  // font-weight: normal;
  // font-family: "Book Antiqua", Palatino, serif;
  // text-shadow: -0.5px -0.125px white;
  text-align: right;
  line-height: 1;
  z-index: 1;
  margin: 20px 50px 0 20px;
}
.title small {
  font-size: 80px;
  vertical-align: super;
  top: -10px;
}

footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px;
  font-size: 1em;
  font-weight: bold;
  color: white;
}

.root {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  background-image: var(--titleBackground);
  background-size: cover;
  background-repeat: no-repeat;
}

.game-selector {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;

  .label {
    color: black;
    font-size: 1.4em;
  }
}
.game-selection-dropdown {
  background-color: transparent;
  border: 1px solid white;
  border-radius: 2px;
  color: white;
  width: 100%;
  font-size: 1.6em;

  .dropdown-toggle {
    background-color: transparent;
    color: white;
    border: none;
    width: 100%;
    margin: 3px 0;
    cursor: pointer;
  }
  .dropdown-toggle:hover {
    background-color: rgba(0, 0, 7, 0.1);
  }
  .dropdown-toggle:focus {
    background-color: rgba(0, 0, 7, 0.1);
  }
  .dropdown-menu {
    background-color: rgba(0, 0, 7, 0.7);
    color: white;
    margin-top: 10px;
    width: 100%;
  }
  .dropdown-item {
    color: white;
    font-size: 1.5em;
  }
  .dropdown-item:hover {
    background-color: rgba(0, 0, 7, 0.4);
  }
}
.dropdown-toggle[aria-expanded="true"]:after {
  transform: rotate(180deg);
}
.dropdown-toggle:after {
  transition: 0.4s;
}
.start-button {
  height: 40px;
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  font-size: 1.5em;
  border-width: 1px !important;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 25px 0 rgba(0, 0, 0, 0.4);
}

.start-button-container {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

// New style UI
.content {
  position: fixed;
  width: 100vw;
  height: 100vh;
}

.game-title-bar {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  text-align: center;

  left: 0px;
  right: 0px;
  top: 15px;
  height: 260px;
  //background-color: red;
  //bottom: 640px;

  .game-title-container {
    padding: 30px;
    border-top: 3px solid white;
    border-bottom: 3px solid white;
    background-color: rgba(0,0,0,0.6);
    width: 100%;

    h1 {
      color: white;
      font-size: 70px;
    }
  }
}

.content-area {
  position: fixed;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  left: 540px;
  right: 540px;
  top: 275px;
  bottom: 90px;
  height: 560px;
  // background-color: red;
  // overflow: hidden;
}

.ca-item {
  margin-bottom: 5px;
}

.title-image {
  object-fit: cover;
  background-color: transparent;
  width: 520px;
  height: 390px;
  border-radius: 5px;
  border: 2px solid white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 25px 0 rgba(0, 0, 0, 0.4);
}

.footer-background {
  position: absolute;
  background-color: rgba(0,0,0,0.6);
  bottom: 0px;
  left: 0px;
  right: 0px;
  height: calc(50px + 0.75em);
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/GameStart.vue